document.addEventListener('DOMContentLoaded', function() {
  function initFaqs() {
    const faqItems = document.querySelectorAll('.faq-item');
    faqItems.forEach(item => {
      const header = item.querySelector('.faq-header');
      if (header && !header.hasAttribute('data-faq-init')) {
        header.addEventListener('click', () => {
          item.classList.toggle('active');
        });
        header.setAttribute('data-faq-init', 'true');
      }
    });
  }

  // Initialize on load
  initFaqs();

  // Re-initialize if Shopify Section is re-rendered (Theme Editor)
  document.addEventListener('shopify:section:load', initFaqs);
});
